export default "__VITE_ASSET__B67rM4G1__"